import { Component } from '@angular/core';
import { WordpressRetrieveService } from '../../wordpress-retrieve.service';

@Component({
  selector: 'app-feed-full-list',
  templateUrl: './feed-full-list.component.html',
  styleUrls: ['./feed-full-list.component.css']
})
  
export class FeedFullListComponent {
  allPosts : any;
  
  constructor(private service:WordpressRetrieveService) {
    this.allPosts = [];
  }
    
  ngOnInit(): void {
    this.service.getAllPosts().subscribe((result)=>{
      // console.log(result);
      this.allPosts = result;
    });
  }
}


